module.exports = __webpack_public_path__ + "img/mv.efb539cf.png";